/* global RdcTracking */

export const trackModalImpression = function(modalName, modalTrigger) {
  if (modalName && modalTrigger) {
    RdcTracking.trackEvent('modalImpression', { modalName, modalTrigger });
  }
};

//Simple helper function since this specific code is in a couple locations
export const trackRmdModalImpression = function(e) {
  const omtag = e.target.attributes['data-omtag'] ? e.target.attributes['data-omtag'].value : '';
  trackModalImpression('homes:modal:rmd', omtag )
}



// WEBPACK FOOTER //
// ./shared_critical/tracking/shared/modal_impression.js